// eslint-disable-next-line no-restricted-syntax
export const emmaName = "MSRB EMMA®";
